module.exports = __webpack_public_path__ + "static/media/vi.cc2e55f0.svg";